import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { RulesScreen } from '../features/rules/RulesScreen';
import { BackLink } from '../components/BackLink';

export const Route = createFileRoute('/tenants_/$tenantId_/rules')({
  component: RulesPage,
});

function RulesPage() {
  const { t } = useTranslation('tenants');
  const { tenantId } = Route.useParams();
  const { data: session } = useSession();

  // Designers may edit templates but not rules — rules decide who gets which signature, which is a
  // different blast radius from changing what one signature looks like.
  const canEdit = hasRole(session, PlatformRole.Editor, tenantId);
  const canView = hasRole(session, PlatformRole.Viewer, tenantId);

  return (
    <Stack gap="sm">
      <BackLink to="/tenants/$tenantId" params={{ tenantId }} search={{ tab: 'rules' }} />

      {!canView ? (
        <Alert color="red" title={t('noAccessRulesTitle')}>
          {t('noRoleBody')}
        </Alert>
      ) : (
        <>
          {!canEdit && (
            <Alert color="blue" variant="light" title={t('readOnlyTitle')}>
              {t('readOnlyRulesBody')}
            </Alert>
          )}
          <RulesScreen tenantId={tenantId} />
        </>
      )}
    </Stack>
  );
}
